//CHECK LICENCE KEY
export const CHECK_COMPANY_LICENCE = (company) => `/clientSpace/check-company-license?company=${company}`
//USERS
export const GET_USERS = "/users";
export const GET_USERS_BY_SA = (id) => `/users/bySuperAdmin/${id}`;
export const ADD_USER = `/auth/register?company=${JSON.parse(sessionStorage.getItem("authUser"))?.company}`;
export const ADD_ADMIN_SPACE = "/clientSpace/admin?companyInitial=xyz";
export const ADD_MULTI_USERS = `/users/register-all?company=${JSON.parse(sessionStorage.getItem("authUser"))?.company}`;
export const UPDATE_USER = "/users";
export const DELETE_USER = "/users";
export const UPLOAD_USER_IMG = (userId) => `/users/${userId}/update-user-profile`;
export const IMAGE_URL_PRINT= "/data-file/print"
///api/v1/data-file/support/{userId}
//ENTERPRISES
export const GET_ENTERPRISES = "/client";
export const ADD_ENTERPRISE = "/client";
export const UPDATE_ENTERPRISE = "/client";
export const DELETE_ENTERPRISE = "/client";
export const ASSIGN_DEMANDE_TO_ENTERPRISE = (data) => `/client/${data.clientId}/auditTasks/${data.auditTaskId}`;

//SPACE
export const GET_SPACES = "/clientSpace";
export const GET_SPACE_BY_COMPANY = (company) => `/clientSpace/company?company=${company}`;
export const GET_SPACES_BY_SUPER_ADMIN_ID = (id) => `/clientSpace/bySuperAdmin/${id}`;
export const ADD_SPACE = `/clientSpace`;
// export const ADD_SPACE = (cl) => `/clientSpace?companyLicense=${cl}`;
export const UPDATE_SPACE = (id) => `/clientSpace/${id}`;
export const DELETE_SPACE = (id) => `/clientSpace/${id}`;
export const GET_SPACES_BY_MANAGER ="/clientSpace";

//DEMANDES
export const GET_QCM = "/qcm";
export const GET_DEMANDES = "/audit-task";
export const GET_ALL_AUDITS = "/audit-task/get-all";
export const ADD_DEMANDE = "/audit-task";
export const ADD_MULTI_TASKS = `/audit-task/register-all?company=${JSON.parse(sessionStorage.getItem("authUser"))?.company}`;
export const UPDATE_DEMANDE = "/audit-task";
export const UPDATE_CABLE = "/cable";
export const UPDATE_BOX_INFOS = (taskId) => `/box/update/${taskId}`;
export const UPDATE_ALL_BOX_IMAGES = (imageName) => `/data-file/update-image?imageName=${imageName}&company=${JSON.parse(sessionStorage.getItem("authUser"))?.company}`;
export const DELETE_DEMANDE = "/audit-task";
export const GENERATE_PDF_REPORT =  (id) =>`/audit-task/${id}/get-task-pdf-report`
export const ADD_DEMANDE_TO_PROJECT = (data) => `/project-type/${data.projectId}/move-task-to-project/${data.taskId}`;
export const ASSIGN_DEMANDE_TO_USER = (data) => `/users/${data.userId}/assign-audit-task-technician/${data.auditTaskId}`;
export const ASSIGN_DEMANDE_TO_ENGINEER = (data) => `/users/${data.userId}/assign-audit-task-engineer/${data.auditTaskId}`;
export const REMOVE_ASSIGNATING_USER_TO_DEMANDE = (data) => `/users/${data.userId}/remove-audit-task/${data.auditTaskId}`;
export const UPDATE_DEMANDE_STATUS = (id) => `/audit-task/${id}/status`;
export const ADD_COMMENT_TO_DEMANDE = (data) => `/audit-task/${data.taskId}/add-audit-task-comment?author=${data.author}&comment=${data.comment}`;
export const GET_HISTORY_AUDIT_BY_REF = (ref) => `/box/getAllAuditTaskByBoxReference?boxReference=${ref}`;
export const AUDIT_TASK_REPORT = (id) => `/audit-task/${id}/get-audit-task-report`;
export const GET_CASSETTE_BY_ID = (id) => `/cassette/${id}/getAllCassettesLine`;
export const GET_IMAGES_AFTER_AUDIT_BY_ID = (taskId) => `/data-file/user/${taskId}/get-task-after-filenames`;
export const CHANGE_TMP_FILE_FOR_BOX =(boxId) => `/box/update-newBoxTypeImage/${boxId}`; 
export const ADD_CASSETTE_LINE = (data) => `/cassette/${data.idCassette}/add-line`
export const EDIT_CASSETTE_LINE = (data) => `/cassette/${data.idCassette}/update-line/${data.idLine}`
export const DELETE_CASSETTE_LINE = (idLine) => `/cassette/delete-line/${idLine}`
export const DELETE_CASSETTE = (id) => `/cassette/${id}`
export const DELETE_BOX_BOTTOM_CASSETTE = (id) => `/box-bottom/${id}`
export const DELETE_CABLE = (id) => `/cable/${id}`
///api/v1/cassette/{idCassette}/update-line/{idLine}
// FILES ENDPOINTS
export const GET_DEMANDE_IMG = (imgName) => `/data-file/${imgName}`;
export const DOWNLOAD_FILE_BY_FILENAME = (fileName) => `/data-file/download-file/${fileName}`;
export const ADD_JOINT_FILE_TO_DEMANDE = (id) => `/data-file/task/${id}/add-joint-file`;
export const GET_JOINT_FILE_TO_DEMANDE = (id) => `/data-file/task/${id}/get-joint-filenames`;
export const ADD_BOX_TYPE_IMAGE = "/data-file/add-box-type-image";
export const GET_BOX_TYPE_IMAGES = "/box-type/get-boxType-and-imagesNames";
export const DELETE_BOX_TYPE_IMAGES = (imgName) => `/data-file/${imgName}`;


//Authenticate
export const GET_USER_LOGGED = "/auth/getUserInfoByUsernameAndToken";
export const POST_JWT_LOGIN = process.env.KEYCLOAK_SERVER;


//Vehicule
export const GET_VEHICULES ="/vehicle";
export const ADD_VEHICULE ="/vehicle/";
export const UPDATE_VEHICULE ="/vehicle";
export const DELETE_VEHICULE ="/vehicle";

//Driver
export const GET_DRIVERS ="/driver";
export const ADD_DRIVER ="/driver/";
export const UPDATE_DRIVER ="/driver";
export const DELETE_DRIVER ="/driver";


//Superadmin
export const GET_SUPERADMIN = "/users/getAllSuperAdmins";
export const ADD_SUPERADMIN = "/auth/superAdmin";
export const UPDATE_SUPERADMIN = "/users/superAdmin";
export const DELETE_SUPERADMIN = "/users/superAdmin";



